export default __webpack_public_path__ + "static/media/fastclix_lancing_kit@3x.63dc68d5.png";